import Select from "react-select";

const SearchSelect = ({
  options = [],
  value,
  onChange,
  placeholder = "Buscar...",
  isLoading = false,
  isClearable = true
}) => {
  return (
    <Select
      options={options}
      value={options.find(opt => opt.value === value) || null}
      onChange={(selected) =>
        onChange(selected ? selected.value : "")
      }
      placeholder={placeholder}
      isLoading={isLoading}
      isClearable={isClearable}
      noOptionsMessage={() => "Sin resultados"}
    />
  );
};

export default SearchSelect;
